import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          "flex min-h-[80px] w-full rounded-md border bg-bg-card px-3 py-2 text-sm shadow-2xs",
          "placeholder:text-text-muted transition-[border-color,box-shadow] duration-150",
          "focus:outline-none focus:border-primary focus:ring-[3px] focus:ring-primary/15",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-bg-muted/50",
          "resize-y",
          error
            ? "border-danger focus:border-danger focus:ring-danger/15"
            : "border-border hover:border-border-strong",
          className,
        )}
        {...props}
      />
    );
  },
);

Textarea.displayName = "Textarea";
